/**
 * @returns the elapsed minutes of the current day
 */
export const getElapsedMinutesOfTheDay = (): number => {
  const date = new Date();
  return date.getHours() * 60 + date.getMinutes();
};

export default getElapsedMinutesOfTheDay;
